import styled from "styled-components";

export const WelcomeStyle = styled.main`
.logo-container {
    display: flex;
    flex-direction: row;
}
.logo-text {
    margin-top: 0.5rem;
    margin-left: 0.5rem;
    color:var(--primary-600);
}
nav {
    width:var(--fluid-width);
    max-width:var(--max-width);
    margin: 0 auto;
    height:var(--nav-height);
    display:flex;
    align-items:center;
}
.page {
    min-height:calc(100vh - var(--nav-height));
    display:grid;
    align-items: center;
    margin-top: -3rem;
}
h1 {
    font-weight: 700;
}
p {
    color:var(--grey-600);
}
.main-img {
    display: none;
}
@media (min-width:992px) {
    .page {
        grid-template-columns: 1fr 1fr;
        column-gap: 3rem;
    }
    .main-img {
        display: block;
    }
}
`;